// latest: zhangmyh 2017-10-21 10:02 pM
import { Model } from 'common'
Model.define('supplydoc.modelproperty', {
  proxy: {},
  meta: {
    id: '',
    name: '',
    groupId: '',
    group: '',
    property: '',
    strategy: '',
    matchStrategy: '', // NOMATCH,MATCH, INCLUDE, GREATER,LESS
    type: '', // INPUT, ENUM, DATE, FILE, REFER;
    typeValue: '', // STRING, NUMBER, REF_ENTTYPE, FILE_XYPJDJ;
    maxLength: '',
    isEditable: '',
    enumValueList: []
  }
})

export default Model.create('supplydoc.modelproperty')



// WEBPACK FOOTER //
// ./src/data/model/docModelProperty/index.js